<template>
    <o-form-group
        :form-state="formState"
        :label="label"
        :message="errorMessages"
        :nolabel="nolabel"
        :type="{ 'is-danger': hasError }"
    >
        <o-flatpickr-wrapper
            :class="input_class"
            :config="config"
            :disabled="_is_readonly"
            :hide-date="hideDate"
            :hide-time="hideTime"
            :include-time="includeTime"
            :inline="inline"
            :no-buttons="noButtons"
            :value="value"
            :placeholder="placeholder"
            @input="on_change"
            v-bind="$attrs"
            v-on="inputListeners"
        >
        </o-flatpickr-wrapper>
    </o-form-group>
</template>

<script>
import FormComponentMixin from "../../../mixins/form_component_mixin";
import OFormGroup from "../OFormGroup";
import OFlatpickrWrapper from "./private/OFlatpickrWrapper";

export default {
    name: "ODateTime",
    components: { OFlatpickrWrapper, OFormGroup },
    mixins: [FormComponentMixin],
    model: {
        value: "value",
        event: "input",
    },
    props: {
        hideTime: { type: Boolean, default: false },
        hideDate: { type: Boolean, default: false },
        includeTime: {
            type: Boolean,
            default: false,
        } /* see OFlatpickrWrapper */,
        config: {
            type: Object,
            default: () => {},
        },
        inline: { type: Boolean, default: false },
        noButtons: { type: Boolean, default: false },
        placeholder: { type: String, default: "Select date" },
    },
};
</script>

<style scoped></style>
